import React from 'react'
import {
  Box,
  Typography
} from '@mui/material';

const FlightDiscount = () => {
  return (
    <>
      <Box className="headingBtnWrap">
        <Typography variant="h1">Discount</Typography>
      </Box>
    </>
  )
}

export default FlightDiscount
